// Components==============
import { faLock, faSave, faUnlock } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CircleButton from 'components/UI/CircleButton/CircleButton';
import { motion } from 'framer-motion';
import React, { useContext, useEffect, useState } from 'react';
import { GlobalContext } from 'utilities/GlobalContext';
import { CalendarContext } from '../../Calendar';
import './Password.module.scss';
// =========================

export default function Password() {
    const [modalIsOpen, setModalIsOpen] = useState(false);

    const { logbookAuthenticated, setLogbookAuthenticated } = useContext(
        GlobalContext
    );

    const { storeLogbook, activeLog, canSave, setCanSave } = useContext(
        CalendarContext
    );
    const [value, setValue] = useState('');
    const [error, setError] = useState('');

    const [logHistory, setLogHistory] = useState<undefined | string>(undefined);

    useEffect(() => {
        setLogHistory(activeLog.key);
        if (logHistory !== activeLog.key) return setCanSave(false);
        if (!canSave) setCanSave(true);
    }, [activeLog]);

    function handleIconClick() {
        if (logbookAuthenticated) {
            setLogbookAuthenticated(false);
            setCanSave(false);
        }
        if (canSave) {
            storeLogbook();
            return setCanSave(false);
        }

        if (logbookAuthenticated) setModalIsOpen(false);
        else setModalIsOpen((prev) => !prev);
    }

    function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
        setError('');
        setValue(e.target.value);
    }

    function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();

        if (value === 'Logboek') {
            setLogbookAuthenticated(true);
            setValue('');
            setError('');
            setModalIsOpen(false);
        } else {
            setError(
                'Wachtwoord is niet juist, voer het juiste wachtwoord in voor: naam@spiek.nl'
            );
        }
    }

    return (
        <div styleName="wrapper">
            <CircleButton onClick={handleIconClick} color="light-grey">
                <FontAwesomeIcon
                    icon={
                        canSave
                            ? faSave
                            : !logbookAuthenticated
                            ? faLock
                            : faUnlock
                    }
                />
            </CircleButton>
            {modalIsOpen && (
                <div styleName="password">
                    <form onSubmit={handleSubmit}>
                        <input
                            type="password"
                            onChange={handleChange}
                            value={value}
                            style={{ border: error ? '2px solid #F53565' : '' }}
                            autoComplete="new-password"
                        />
                        <motion.button
                            type="submit"
                            whileHover={{ scale: 1.03 }}
                            initial={{ scale: 1 }}
                            whileTap={{ scale: 0.97 }}
                        >
                            <FontAwesomeIcon icon={faUnlock} />
                        </motion.button>
                    </form>
                    {error && <p>{error}</p>}
                </div>
            )}
        </div>
    );
}
